import { render, staticRenderFns } from "./addtorviews.vue?vue&type=template&id=fa112dde"
import script from "./addtorviews.vue?vue&type=script&lang=js"
export * from "./addtorviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports